export default __webpack_public_path__ + "locales/sr-Cyrl-RS/BackupCodesDialog.json?hash=7e7a7f4919d3dcc12a6980111ae18a54";